<!-- --------------------------------------------------------------------->
<!-- Displays one "Verlauf", that is one part of a track on xs  devices -->
<!-- --------------------------------------------------------------------->

<template>
  <!-- xs layout: multi-row list -->
  <div :id="item.rowId" :style="{ background: item.bgColor }" class="d-flex flex-row verlauf verlauf-xs flex-no-wrap">
    <div class="xs-point pl-2" style="padding-right: 10px; height: 60px">
      <time-line-point :small="!item.start && !item.end" :bottomConnection="!item.end && !isLastItem" :themeName="themeName"></time-line-point>
    </div>
    <div class="d-flex flex-column flex-grow-1" style="height: 60px">
      <div class="d-flex flex-row small-row-1" :class="{ bold: bold }">
        <div class="xs-location flex-grow-1">{{ item.location }}</div>
        <div class="xs-an" v-if="item.end || item.an !== item.ab" :id="`TE_${item.ab}`" :class="{ bold: bold }">
          <!--{{ getLocalTimeFromMinutesAfterMidnight(item.an) }}-->
          {{ item.anFormatted }}
        </div>
        <!-- <div class="xs-an">{{ isLastLocation || anAndAb.an !== anAndAb.ab ? getLocalTimeFromMinutesAfterMidnight(anAndAb.an) : '' }}</div> -->
        <div class="xs-an" v-else></div>
        <!-- <div class="xs-an" v-else :class="{ bold: bold }"></div> -->

        <div class="xs-ab" v-if="!item.start && item.end" :id="`TLAST_${item.ab}`"></div>
        <div class="xs-ab" v-else :id="`T_${item.ab}`" :class="{ bold: bold }">
          <!--{{ getLocalTimeFromMinutesAfterMidnight(item.ab) }}-->
          {{ item.abFormatted }}
        </div>

        <!-- <div class="xs-ab" :id="`T_${anAndAb.ab}`">{{ isLastLocation ? '' : getLocalTimeFromMinutesAfterMidnight(anAndAb.ab) }}</div> -->
      </div>
      <div class="d-flex flex-row small-row-2">
        <template v-for="col in perlschnurColumnsXs">
          <div v-if="col.key === 'abbr'" :key="col.key" class="xs-abbreviation">{{ item.abbreviation }}</div>
          <div v-if="col.key === 'line'" :key="col.key" class="xs-line">{{ $t('line') }}: {{ item.line }}&nbsp;</div>
          <div v-if="col.key === 'kurs'" :key="col.key" class="xs-track">{{ $t('track') }}: {{ item.track }}&nbsp;</div>
          <div v-if="col.key === 'custom1'" :key="col.key" class="xs-track">{{ $t(col.titleKey) }}: {{ item.custom1 }}&nbsp;</div>
          <div v-if="col.key === 'zone'" :key="col.key" class="xs-zone">{{ $t('zone') }}: {{ item.zone }}&nbsp;</div>
        </template>
      </div>
      <div class="d-flex flex-row small-row-2">
        <div class="xs-notice" v-html="item.comment"></div>
        <div class="xs-connection">
          <anschluss v-if="item.connection" :anschluss="item.connection" :fahrtDateAsTime="item.fahrtDateAsTimeInMs"></anschluss>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Anschluss from './Anschluss';
import TimeLinePoint from './TimeLinePoint.vue';
import dateUtils from '@/common/dateUtils';

export default {
  name: 'Verlauf_xs',

  components: {
    Anschluss,
    TimeLinePoint,
  },

  props: {
    item: Object,
    perlschnurColumnsXs: Array,
    configuredTimeFormat: String,
    themeName: String,
    isLastItem: Boolean,
    isHighlighted: Boolean,
    dateString: String,
  },

  computed: {
    bold() {
      return this.item.end === true || this.item.start === true;
    },
    containerClasses() {
      let clz;

      if (this.isHighlighted) {
        clz += ` marked-row--${this.themeName}`;
      }
      return clz;
    },
  },
  methods: {
    getLocalTimeFromMinutesAfterMidnight(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
<style lang="scss">
@import './perlschnur.scss';
</style>
